import * as React from 'react'
import { useState, useEffect } from 'react'
import { SortableMultiValue, SortableAsyncSelect, arrayMove } from '../../sortable_select/SortableSelect'
import { loadOrderNumberOptions } from '../../../api/jobnumbers'

interface SelectedJobnumberShape {
  value: number
  label: string
  user_jobnumber_id?: number
}

interface SelectJobnumbersProps {
  defaultJobnumbers: Array<SelectedJobnumberShape>
  inputName: string
  label: string
  selectId: string
}

export default function SelectJobnumbers({ defaultJobnumbers, inputName, label, selectId }: SelectJobnumbersProps) {
  const [selectedJobnumbers, setSelectedJobnumbers] = useState<Array<SelectedJobnumberShape>>(defaultJobnumbers || [])
  const [removedJobnumbers, setRemovedJobnumbers] = useState<Array<SelectedJobnumberShape>>([])

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newValue = arrayMove(selectedJobnumbers, oldIndex, newIndex)
    setSelectedJobnumbers(newValue)
  }

  useEffect(() => {
    // Track removed items when selectedJobnumbers changes
    const currentIds = new Set(selectedJobnumbers.map(jn => jn.value))
    const newlyRemoved = defaultJobnumbers.filter(jn =>
      jn.user_jobnumber_id && !currentIds.has(jn.value)
    )
    setRemovedJobnumbers(newlyRemoved)
  }, [selectedJobnumbers, defaultJobnumbers])

  return (
    <div>
      <label htmlFor={selectId}>{label}</label>
      <SortableAsyncSelect
        axis="xy"
        onSortEnd={onSortEnd}
        distance={4}
        getHelperDimensions={({ node }) => node.getBoundingClientRect()}
        // @ts-ignore
        id={selectId}
        cacheOptions
        loadOptions={loadOrderNumberOptions}
        defaultOptions
        isClearable
        isMulti
        components={{
          MultiValue: SortableMultiValue,
        }}
        value={selectedJobnumbers}
        onChange={e => setSelectedJobnumbers(e ? [...e] : [])}
        required
      />
      {selectedJobnumbers.map((jn, index) => (
        <div key={jn.value}>
          <input type="hidden" name={`${inputName}[${index}][jobnumber_id]`} value={jn.value} />
          <input type="hidden" name={`${inputName}[${index}][position]`} value={index + 1} />
          {jn.user_jobnumber_id && (
            <input type="hidden" name={`${inputName}[${index}][id]`} value={jn.user_jobnumber_id} />
          )}
        </div>
      ))}
      {removedJobnumbers.map((jn, index) => (
        <div key={`removed-${jn.value}`}>
          <input type="hidden" name={`${inputName}[${selectedJobnumbers.length + index}][id]`} value={jn.user_jobnumber_id} />
          <input type="hidden" name={`${inputName}[${selectedJobnumbers.length + index}][_destroy]`} value="1" />
        </div>
      ))}
    </div>
  )
}
